import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, Text, Tooltip, Card } from '@hub-la/design-system';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { DocumentType } from '../../domain/enums/bank-account.js';

const SelectModality = () => {
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const {
    t
  } = useTranslation();
  return jsxs(Stack, Object.assign({
    direction: "column",
    spacing: 4
  }, {
    children: [jsxs(Stack, Object.assign({
      direction: "row",
      spacing: 1
    }, {
      children: [jsx(Text, {
        children: t('accountVerification.form.modality.label')
      }), jsx(Tooltip, Object.assign({
        trigger: "hover",
        title: jsx(Text, {
          children: t('accountVerification.form.modality.tooltip')
        }),
        arrow: true
      }, {
        children: jsx(InfoOutlinedIcon, {})
      }))]
    })), jsxs(Stack, Object.assign({
      direction: ['column', 'row'],
      gap: [3, 6]
    }, {
      children: [jsx(Card, Object.assign({
        variant: "outlined",
        hasHover: true,
        selected: values.businessOwner.documentType === DocumentType.CPF,
        onClick: () => setFieldValue('businessOwner.documentType', DocumentType.CPF)
      }, {
        children: jsxs(Stack, Object.assign({
          direction: "row",
          alignItems: "center",
          spacing: 4
        }, {
          children: [jsx(BadgeOutlinedIcon, {}), jsx(Text, {
            children: t('accountVerification.form.modality.cpf')
          })]
        }))
      })), jsx(Card, Object.assign({
        variant: "outlined",
        hasHover: true,
        selected: values.businessOwner.documentType === DocumentType.CNPJ,
        onClick: () => setFieldValue('businessOwner.documentType', DocumentType.CNPJ)
      }, {
        children: jsxs(Stack, Object.assign({
          direction: "row",
          alignItems: "center",
          spacing: 4
        }, {
          children: [jsx(DomainOutlinedIcon, {}), jsx(Text, {
            children: t('accountVerification.form.modality.cnpj')
          })]
        }))
      }))]
    }))]
  }));
};

export { SelectModality };
